import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
import './assets/css/index.css';
// import 'bootstrap/dist/css/bootstrap.min.css';

const injectTapEventPlugin = require('react-tap-event-plugin');

injectTapEventPlugin();

ReactDOM.render(
  (
    <App />
  ), document.getElementById('root'),
);



// WEBPACK FOOTER //
// ./src/index.js